export default __webpack_public_path__ + "411e4db332b364f1ae78c29fc9125146.png";